export const decodeBase64 = (base64: string) => atob(base64);
export const encodeBase64 = (str: string) => btoa(str);
